import React from 'react';
import { FadeIn } from './FadeIn';
import { CountdownTimer } from './CountdownTimer';
export function HeroSection() {
  const scrollToOffer = (e: React.MouseEvent) => {
    e.preventDefault();
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-12 pb-20 px-4 md:pt-20 md:pb-32 overflow-hidden bg-gradient-to-b from-green-deep to-green-mint" data-id="element-127">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="inline-block bg-orange-warm text-white text-xs md:text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wide mb-8 shadow-lg" data-id="element-130">
            ESPECIAL DE HOY · APROVECHA LA OPORTUNIDAD
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-131">
          <h1 className="text-white font-heading font-bold text-3xl md:text-5xl lg:text-6xl leading-tight mb-6" data-id="element-132">
            Tu hijo ya tuvo suficientes antibióticos.
            <br className="hidden md:block" data-id="element-133" />
            <span className="text-cream" data-id="element-134">
              Es hora de que su cuerpo aprenda a defenderse solo.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-135">
          <p className="text-cream/90 font-body text-base md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-136">
            El protocolo paso a paso que miles de mamás usan para construir un
            sistema inmune a prueba de inviernos — desde la cocina, sin
            medicamentos, en 90 días.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} className="flex flex-col items-center" data-id="element-137">
          <div className="relative mb-8" data-id="element-138">
            <div className="absolute inset-0 bg-white/20 blur-2xl rounded-full" data-id="element-139"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rzcGwWD84Gh6ZaFZeZT5Q2/libroinmunidadtotal.png" alt="Libro Inmunidad Total" className="relative z-10 w-full max-w-[280px] md:max-w-[350px] mx-auto drop-shadow-2xl rounded-xl" data-id="element-140" />
          </div>

          <button onClick={scrollToOffer} className="w-full md:w-auto bg-green-lime text-white font-bold text-lg py-4 px-8 rounded-xl shadow-glow hover:scale-105 transition-transform duration-300 animate-pulse-slow" data-id="element-141">
            VER LA OFERTA COMPLETA →
          </button>
        </FadeIn>
      </div>
    </section>;
}